/**
 * Safari PWA helper functions
 */

/**
 * Detects if the app is running as a PWA on iOS Safari
 * @returns {boolean} True if running as PWA on iOS
 */
export const isIOSPwa = () => {
  return (
    // Check for iOS device
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    // Check if standalone mode (added to home screen)
    window.navigator.standalone === true
  );
};

/**
 * Detects if the app is running on Safari
 * @returns {boolean} True if running on Safari
 */
export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

/**
 * Forces a refresh of the page for Safari PWAs
 * This can help with screen rendering issues
 */
export const refreshSafariPwa = () => {
  if (isIOSPwa()) {
    // Force a refresh by scrolling slightly to trigger repaints
    window.setTimeout(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    }, 300);
  }
};

/**
 * Sets up event listeners for Safari PWA
 * Call this in your main app component
 */
export const setupSafariPwaListeners = () => {
  if (isIOSPwa()) {
    // Add a focus event listener to force refresh when returning to the app
    window.addEventListener('focus', refreshSafariPwa);
    
    // Handle orientation changes
    window.addEventListener('orientationchange', () => {
      // Small delay to allow orientation to complete
      setTimeout(refreshSafariPwa, 200);
    });
    
    // Initial refresh
    refreshSafariPwa();
  }
};

/**
 * Detects if user is on iOS and suggests adding to home screen
 * @returns {boolean} True if user should add to homescreen
 */
export const shouldSuggestAddToHomeScreen = () => {
  // Is iOS but not in PWA mode
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) &&
    window.navigator.standalone !== true &&
    isSafari()
  );
}; 